// extracted by mini-css-extract-plugin
export default {"tabBar":"tab-bar_tabBar__2G1Xb"};